<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      disable-pagination
      disable-sort
      hide-default-footer
      :headers="headers"
      :items="entradas"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.origem_id }}</td>
            <td>{{ item.id }}</td>
            <td>{{ item.data | dataBR }}</td>
            <td>
              <div>{{ item.fornecedor }}</div>
              <template v-if="item.grade">
                <v-chip
                  v-for="(_grade, index) in item.grade"
                  class="mr-2"
                  x-small 
                  color="grey lighten-2"
                  :key="index"
                >{{_grade.descricao}}</v-chip>
              </template>
            </td>
            <td class="text-right">{{ item.quantidade | valorBR(0) }}</td>
            <td class="text-right">{{ item.balanco | valorBR(0) }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "HistoricoEntradas",
  props: {
    entradas: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        { text: "Entrada", value: "origem_id", width: '100px' },
        { text: "Lote", value: "id", width: '100px' },
        { text: "Data", value: "data", width: '100px' },
        { text: "Fornecedor", value: "fornecedor" },
        { text: "Quantidade", value: "quantidade", width: '130px', align: "right" },
        { text: "Disponível", value: "saldo", width: '130px', align: "right" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
